/** Единый путь к логотипу в `public/logo.svg`. */
export const LOGO_SRC = '/logo.svg'
